<template>
  <div style="position:relative;">
    <a-spin class="load" v-show="loading"/>
    <div class="select_t">
      <span style="color: #999;">类型：</span>
      <span :class="selectCurrent==index?'spanActiveMain':'spanText'" v-for="(item, index) in selectTop" :key="index"
            @click="searchSelectMain(index,item)">{{ item.name }}</span>
    </div>
    <div v-if="bookList.length==0">
      <a-empty style="margin-top:200px;"/>
    </div>
    <div v-else>
      <ul class="bookList">
        <li :class="item.isFree===0?'bookDetail':'bookDetailLock'" v-for="(item,index) in bookList" :key="index"
            @click="lookDetail(item)">
          <div class="arcticle">
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_jiaoxue.jpg" alt="Lock Icon"
                 v-if="item.articleType===1"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_gaokao.png" alt="Lock Icon"
                 v-if="item.articleType===2"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_jiaoxue.jpg" alt="Lock Icon"
                 v-if="item.articleType===3"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_sheji.jpg" alt="Lock Icon"
                 v-if="item.articleType===4"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_kecheng.jpg" alt="Lock Icon"
                 v-if="item.articleType===5"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_shisheng.png" alt="Lock Icon"
                 v-if="item.articleType===6"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_wenben.png" alt="Lock Icon"
                 v-if="item.articleType===7"/>
            <img class="arcicle-icon" src="../../assets/image/ic_teacher_xiezuo.jpg" alt="Lock Icon"
                 v-if="item.articleType===8"/>
            <div class="arcticle-detail">
              <div class="title">{{ item.title }}</div>
              <div class="time">
                <img class="userPhoto" src="../../assets/image/ic_teacher_time.png" alt=""/>
                <span class="date">{{ format.format(item.createDate) }}</span>
              </div>
              <div class="author">
                <img class="userPhoto" src="../../assets/image/ic_teacher_name.png" alt=""/>
                <span class="userName">{{ item.authorName }}</span>
              </div>
              <!-- <img class="classImg" src="../../assets/teacherRoad/14.png" alt="" />
              <span class="classType">{{format.articleType(item.articleType)}}</span> -->
            </div>
          </div>
          <!-- <div class="content" v-html="item.content"></div> -->

          <div class="overlay" v-if="item.isFree===1"></div>
          <img class="lock-icon" src="../../assets/image/lock.png" alt="Lock Icon" v-if="item.isFree===1"/>
        </li>
      </ul>
      <div style="text-align:center;margin-top:20px;height:50px;">
        <a-config-provider>
          <a-pagination
              show-quick-jumper
              :page-size="pageSize"
              @change="handleListChange"
              show-less-items
              :total=total
          />
        </a-config-provider>
      </div>
    </div>

  </div>
</template>

<script>
import format from '@/utils/format.js'

export default {
  name: 'snailBookList',
  data() {
    return {
      format,
      loading: false,
      selectTop: [
        {name: '全部', id: ''}, {name: '高考点拨', id: 2}, {name: '教学反思', id: 3}, {name: '教学设计', id: 4},
        {name: '课程标准', id: 5}, {name: '师生风采', id: 6}, {name: '文本解读', id: 7}, {name: '写作指导', id: 8}
      ],
      selectCurrent: 0,
      pageSize: 10,
      pageNum: 1,
      total: 1,
      current: 1,
      articleType: '',
      bookList: [],
      bookStatus: '', // 空全部 1审核中 0未审核 2未通过 3 已发布
      fileType: false
    }
  },
  mounted() {
    this.getList()
  },
  watch: {
    $route() {
      this.bookStatus = this.$route.query.status
      this.getList()
    }
  },
  methods: {
    // 分页获取文章列表/ebook/teacher/article/getMyArticleList
    getList() {
      const param = {
        articleType: this.articleType,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        status: this.bookStatus
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/article/getArticleList',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.bookList = res.resultData.list
          this.total = res.resultData.total
        }
      })
    },
    searchSelectMain(index, item) {
      this.selectCurrent = index
      this.articleType = item.id
      this.pageNum = 1
      this.getList()
    },

    handleListChange(current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getList()
    },
    lookDetail(item) {
      if (item.isFree === 0) {
        sessionStorage.setItem('snailsID', item.id)
        if (item.filePath) {
          this.fileType = item.filePath.split('.')[1]
        } else {
          this.fileType = false
        }
        if (!this.fileType) {
          this.$router.push({name: 'snailBookListDetail'})
        }
        if (this.fileType == 'doc' || this.fileType == 'docx' || this.fileType == 'pdf') {
          const a = document.createElement('a')
          a.setAttribute('href', this.$resBasePath + '/' + item.filePath)
          a.setAttribute('target', '_blank')
          window.open(a)
        }
      } else {
        this.$message.warning('请开通教材后查看')
      }
    }
  }
  // beforeRouteEnter(to,form,next){
  //     console.log(to)
  //     debugger
  //     if(form.name=='snailBookListDetail'){
  //         _this.$router.push({name: 'snailBookListDetail'})
  //     }
  //     if(to.name=='snailBookList'){
  //         _this.$router.push({name: 'snailBookList'})
  //     }
  //     next()
  // }
}
</script>

<style lang="less" scoped>
.load {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(50%, 50%);
  z-index: 99;
}

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.select_t {
  height: 50px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 50px;

  .spanText {
    display: inline-block;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    color: #999;
    font-size: 14px;
    text-align: center;
  }
}

.bookList {
  min-height: 600px;
  padding: 0 50px;

  .bookDetail {
    cursor: pointer;
    margin-top: 15px;
    border-bottom: 1px solid #F0F0F0;

    .arcticle {
      display: flex;

      .arcicle-icon {
        height: 90px;
        width: 90px;
        margin-left: 10px;
        margin-top: 12px;
        border-radius: 50%;
      }

      .arcticle-detail {
        font-size: 16px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        color: #333;
        line-height: 32px;
        margin-top: 10px;
        margin-left: 10px;

        .title {
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: #333;
          line-height: 32px;
          height: 32px;
          margin-left: 10px;
        }
        &:hover {
          .title {
            color: @primary-color;
          }

        }

        .author {
          .userPhoto {
            width: 15px;
            height: 15px;
            margin-left: 10px;
          }

          .userName {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-left: 5px;
          }
        }

        .time {
          .userPhoto {
            width: 15px;
            height: 15px;
            margin-left: 10px;
          }

          .date {
            margin-left: 4px;
            font-size: 12px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            color: #999999;
          }

        }

      }
    }
  }

  .bookDetailLock {
    cursor: pointer;
    margin-top: 15px;
    border-bottom: 1px solid #F0F0F0;
    position: relative;

    .arcticle {
      display: flex;

      .arcicle-icon {
        height: 90px;
        width: 90px;
        margin-left: 10px;
        margin-top: 12px;
        border-radius: 50%;
      }

      .arcticle-detail {
        font-size: 16px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        color: #333;
        line-height: 32px;
        margin-top: 10px;
        margin-left: 10px;

        .title {
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: #333;
          line-height: 32px;
          height: 32px;
          margin-left: 10px;
        }
        &:hover {
          .title {
            color: @primary-color;
          }

        }

        .author {
          .userPhoto {
            width: 15px;
            height: 15px;
            margin-left: 10px;
          }

          .userName {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-left: 5px;
          }
        }

        .time {
          .userPhoto {
            width: 15px;
            height: 15px;
            margin-left: 10px;
          }

          .date {
            margin-left: 4px;
            font-size: 12px;
            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
            font-weight: 400;
            color: #999999;
          }

        }

      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3); /* 透明灰色蒙层 */
      border-radius: 6px;
    }

    .lock-icon {
      position: absolute;
      height: 30px;
      width: 30px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      /* 根据实际需要设置锁图标的样式 */
    }
  }

}

.spanActiveMain {
  display: inline-block;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border-radius: 16px;
  color: @primary-color;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}
</style>
